enum FormType {
    EVALUATION = "evaluation",
    SURVEY = "survey",
    ASSESSMENT = "assessment",
}

export default FormType;
